
import DealListItem from '@/components/DealListItem.vue'
export default {
  name: 'DealList',
  components: { DealListItem },
  props: {
    deals: Array,
  },
}
